import type {
  AriaRole,
  KeyboardEvent,
  MouseEvent,
  ReactNode,
  SyntheticEvent,
} from "react";

import { useScrollOnMount } from "metabase/common/hooks/use-scroll-on-mount";

import { BaseItemRoot } from "./SelectListItem.styled";

export interface BaseSelectListItemProps {
  id: string | number;
  htmlId?: string;
  name: string;
  onSelect: (id: string | number, event: SyntheticEvent) => void;
  children: ReactNode;
  isSelected?: boolean;
  size?: "small" | "medium";
  className?: string;
  hasLeftIcon?: boolean;
  hasRightIcon?: boolean;
  role?: AriaRole;
  tabIndex?: number;
  as?: any;
}

export function BaseSelectListItem({
  id,
  htmlId,
  onSelect,
  isSelected = false,
  size = "medium",
  className,
  as = BaseItemRoot,
  role = "menuitem",
  tabIndex = 0,
  children,
  ...rest
}: BaseSelectListItemProps) {
  const ref = useScrollOnMount<HTMLLIElement>();
  const Root = as;
  return (
    <Root
      id={htmlId}
      ref={isSelected ? ref : undefined}
      isSelected={isSelected}
      aria-selected={isSelected}
      role={role}
      tabIndex={tabIndex}
      size={size}
      onClick={(event: MouseEvent) => onSelect(id, event)}
      onKeyDown={(event: KeyboardEvent) =>
        event.key === "Enter" &&
        !event.nativeEvent.isComposing &&
        onSelect(id, event)
      }
      className={className}
      {...rest}
    >
      {children}
    </Root>
  );
}

BaseSelectListItem.Root = BaseItemRoot;
